import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { CommonCieModel } from 'src/app/model/common/cie';
import { GeneralDiagnosticViewModel } from 'src/app/model/general/diagnostic.view';
import { generalConsultActions } from 'src/app/store/general/general.action';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GeneralConsultDiagnosticService extends BaseService {
  constructor(protected store: Store<any>, protected rest: RestService) {
    super();
  }

  loadDiagnostics = (turn: number): Observable<GeneralDiagnosticViewModel[]> =>
    this.rest
      .get<GeneralDiagnosticViewModel[]>({
        url: `${environment.endpoints.general}/diagnostic/{turn}`,
        urlParams: { turn },
      })
      .pipe
      // map((diagnostics) =>
      //   !diagnostics || diagnostics.length === 0
      //     ? []
      //     : diagnostics.map(this.setDiagnosticInformation)
      // )
      ();

  isSaving = (): Observable<boolean> =>
    this.store.select('general', 'consult', 'saving');

  save = (
    turn: number,
    body: GeneralDiagnosticViewModel[],
    remove: number[]
  ): Observable<GeneralDiagnosticViewModel[]> =>
    this.rest
      .post<GeneralDiagnosticViewModel[]>({
        url: `${environment.endpoints.general}/diagnostic`,
        body,
        params: { turn, remove },
      })
      .pipe(
        tap(
          () => this.addToSaved(),
          () => this.addToSaved()
        ),
        map((result) => {
          if (result.length === 0) {
            return [{ turn }];
          }
          return result;
        })
      );

  addToSaved = (value: number = 1) =>
    this.store.dispatch(generalConsultActions.addToSavedAction({ value }));

  fillCieSuggestion = (query: string): Observable<CommonCieModel[]> =>
    this.rest.get<CommonCieModel[]>({
      url: `${environment.endpoints.common}/cie`,
      params: { query },
    });

  setDiagnosticInformation = (diagnostic: GeneralDiagnosticViewModel) => ({
    ...diagnostic,
    cieHelp: {
      id: diagnostic.cie,
      code: diagnostic.code,
      displayName: diagnostic.displayName,
      description: diagnostic.description,
    },
  });
}
